/**
 * User initials for avatar chips (sidebar, settings).
 *
 * @example
 * getBusinessUserInitials("Abhinav Khushraj");
 * // "AK"
 */
export const getBusinessUserInitials = (name) => {
  const trimmed = String(name || "").trim();
  if (!trimmed) return "?";
  const parts = trimmed.split(/\s+/);
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};
